// @flow
import Debug from 'debug';
import { useEffect } from 'react';

const debug = Debug('amms:modules:openlayers:useEvent');

export default function useEvent(instance, eventName, listener) {
    useEffect(() => {
        if(instance && listener) {
            debug(`Adding event listener for ${eventName}`, instance);
            instance.on(eventName, listener);
        }

        return () => {
            if(instance && listener) {
                debug(`Removing event listener for ${eventName}`, instance);
                instance.un(eventName, listener);
            }
        };
    }, [instance, eventName, listener]);
}